const ratios = {
    horizontal: 3 / 2,
    horizontalWide: 16 / 9,
    square: 1,
    vertical: 3 / 4,
    verticalWide: 4 / 5,
};

export default ratios;
